<pay-dialog-title>{{config.title | translate}}</pay-dialog-title>
<pay-dialog-body>
   <div class="mb-5"> {{config.content | translate: config.contentParams}}</div>
    <div class="ml-6 mr-6" [formGroup]="datetimeForm" [payFormSubmitted]="submitted">
        <pay-datetime ihdAutoFocus
                      formControlName="datetime"></pay-datetime>

        <pay-form-messages [form]="datetimeForm" name="datetime" [submitted]="submitted">
            <pay-form-message name="maxDatetime">{{'Certificate.Expiry.Year.Validation' | translate}}</pay-form-message>
            <pay-form-message name="minDatetime">{{'Certificate.Expiry.Year.Validation' | translate}}</pay-form-message>
        </pay-form-messages>
    </div>
</pay-dialog-body>
<pay-dialog-actions>
    <pay-button-group class="c-btn-group--column">
        <button payButton type="button"
                class="c-btn--feature c-btn--block c-btn--lg mb-2"
                [disabled]="isClosing"
                (click)="submit()">
            {{'Common.Confirm'|translate}}
        </button> 
        <button payButton type="button"
                class="c-btn--link-primary c-btn--block c-btn--lg"
                payDialogClose
                [disabled]="isClosing">
            {{'Common.Cancel'|translate}}
        </button>
        
    </pay-button-group>
</pay-dialog-actions>
